export default __webpack_public_path__ + "static/media/Beard_3_C5.1765b199.svg";